import React, { useState } from 'react';
import axios from 'axios';

const SolarCalculator = () => {
  const [formData, setFormData] = useState({
    propertyType: '',
    address: '',
    name: '',
    email: ''
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post('/wp-json/solar-calculator/v1/submit', formData);
      console.log('Success:', response.data);
    } catch (error) {
      console.error('Error:', error);
    }
  };

  return (
    <div className="solar-calculator">
      <h2>Solar Savings Calculator</h2>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Property Type</label>
          <select
            value={formData.propertyType}
            onChange={(e) => setFormData({...formData, propertyType: e.target.value})}
          >
            <option value="">Select Type</option>
            <option value="residential">Residential</option>
            <option value="commercial">Commercial</option>
          </select>
        </div>
        
        <div className="form-group">
          <label>Address</label>
          <input
            type="text"
            value={formData.address}
            onChange={(e) => setFormData({...formData, address: e.target.value})}
          />
        </div>

        <div className="form-group">
          <label>Name</label>
          <input
            type="text"
            value={formData.name}
            onChange={(e) => setFormData({...formData, name: e.target.value})}
          />
        </div>

        <div className="form-group">
          <label>Email</label>
          <input
            type="email"
            value={formData.email}
            onChange={(e) => setFormData({...formData, email: e.target.value})}
          />
        </div>

        <button type="submit">Calculate Savings</button>
      </form>
    </div>
  );
};

export default SolarCalculator;